<template>
  <div
    class="record-popup popup parking-record is-long"
  >
    <div class="modal-overlay" @click="close" />
    <v-menu
      absolute
      attach
      :value="true"
      :close-on-content-click="false"
      :close-on-click="false"
      content-class="modal-content no-scroll"
    >
      <div v-if="warnings.length" class="file-zone">
        <h3 class="main-title warning">{{ $t('import_warnings_title') }}</h3>
        <div class="warning-blocks">
          <div v-if="duplicateWarnings.length" class="warning-block">
            <p>{{ $tc('duplicates_warning_text', duplicateWarnings.length, { warningCount: duplicateWarnings.length }) }}</p>
            <p>
              {{ $tc('affected_plates', duplicateWarnings.length) }}
              <span v-for="(warning, index) in duplicateWarnings" :key="index">
                <b class="warning-plate">{{ warning.details.row.car_plate }}</b>{{ getSeparator(index, duplicateWarnings) }}
              </span>
            </p>
          </div>
          <div v-if="overlapAdjustedWarnings.length" class="warning-block">
            <p>{{ $tc('overlap_adjusted_warning_text', overlapAdjustedWarnings.length, { warningCount: overlapAdjustedWarnings.length }) }}</p>
            <p>
              {{ $tc('affected_plates', overlapAdjustedWarnings.length) }}
              <span v-for="(warning, index) in overlapAdjustedWarnings" :key="index">
                <b class="warning-plate">{{ warning.details.row.car_plate }}</b>{{ getSeparator(index, overlapAdjustedWarnings) }}
              </span>
            </p>
          </div>
        </div>
        <v-btn
          class="main-btn px-4 py-2"
          block
          @click="close"
        >
          {{ $t('done') }}
        </v-btn>
      </div>
      <div v-else-if="isSuccess" class="file-zone">
        <h3 class="main-title">{{ $t('success') }}</h3>
        <v-btn
          class="main-btn px-4 py-2"
          block
          @click="close"
        >
          {{ $t('done') }}
        </v-btn>
      </div>
      <div v-else class="file-zone">
        <h3 class="main-title">{{ $t('import_data') }}</h3>
        <v-file-input
          v-model="file"
          :label="$t('select_excel_file')"
          outlined
          dense
          accept=".csv,.xls,.xlsx"
          :error="Boolean(isErrorMessage)"
          :error-messages="isErrorMessage"
          :disabled="isLoading"
        />
        <v-btn
          class="main-btn px-4 py-2"
          block
          :disabled="!file || isLoading"
          @click="upload"
        >
          {{ isLoading ? $t('importing') : $t('import') }}
        </v-btn>
      </div>
    </v-menu>
  </div>
</template>

<script>
import { base } from "@/axios-api";

export default {
  name: "UploadExcelFile",
  data() {
    return {
      file: null,
      isSuccess: false,
      isErrorMessage: '',
      isLoading: false,
      warnings: [],
    };
  },
  computed: {
    duplicateWarnings() {
      return this.warnings.filter(warning => warning.code === "duplicate_row");
    },
    overlapAdjustedWarnings() {
      return this.warnings.filter(warning => warning.code === "overlap_adjusted");
    },
  },
  watch: {
    file() {
      this.isErrorMessage = '';
    },
  },
  methods: {
    close() {
      if (!this.isLoading) {
        this.$emit('close');
      }
    },
    upload() {
      this.isLoading = true;
      const formData = new FormData();
      formData.append('file', this.file);
      base({
        url: '/guests/custom_file/upload',
        data: formData,
        method: 'POST',
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((data) => {
        this.warnings = data?.data?.warnings ? data.data.warnings : [];
        this.isSuccess = true;
        this.$emit('success');
      }).catch(async (err) => {
        this.file = null;
        await this.$nextTick;
        if (err.response?.data?.code === 'invalid_file') {
          this.isErrorMessage = this.$t('invalid_file_import', {rowNumber: err.response.data.error.row});
        } else {
          this.isErrorMessage = this.$t('error_short');
        }
      }).finally(() => {
        this.isLoading = false;
      });
    },
    getSeparator(index, array) {
      if (index === array.length - 1) {
        return '.';
      }
      return ', ';
    }
  },
}
</script>

<style scoped lang="scss">

.main-title {
  text-align: center;

  &.warning {
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;
    &::before {
      content: '';
      background-image: url("~@/assets/images/warning.webp");
      background-size: contain;
      background-repeat: no-repeat;
      width: 48px;
      height: 48px;
    }
  }
}

.warning-blocks {
  display: flex;
  flex-direction: column;
  gap: 32px;
  p {
    margin: 0;
  }
}

.warning-block {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.file-zone {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

:deep(.error--text .v-input__slot fieldset) {
  border: 2px solid red;
}

:deep(.theme--light.v-btn.v-btn--disabled) {
  background-color: rgba($green-color, 0.70) !important;
}

.main-btn {
  width: 100%;
}
</style>
